import { Helpers } from '../../helpers';
import { IFluidSystem } from '../../interfaces/ifluid-system';
import { CompletionDesign } from '../completion-design';
import { ProjectCompletionsParameter } from '../project-completions-parameter';

export class FluidSystemBase {
  FluidSystemId: number;
  Description: string;
  SortOrder: number | null;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  CompletionDesigns_FluidSystem?: Array<CompletionDesign> | null;
  ProjectCompletionsParameters_FluidSystem?: Array<ProjectCompletionsParameter> | null;

  constructor(item?: IFluidSystem) {
    if (item) {

      this.FluidSystemId = item.FluidSystemId;
      this.Description = item.Description;
      this.SortOrder = item.SortOrder;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.CompletionDesigns_FluidSystem = Helpers.createClassArray(CompletionDesign, item.CompletionDesigns_FluidSystem);
      this.ProjectCompletionsParameters_FluidSystem = Helpers.createClassArray(ProjectCompletionsParameter, item.ProjectCompletionsParameters_FluidSystem);
    }
  }
}